const bus = require('ngraph.events')({});

export default bus;
